<template>
  <el-col class="assembly_box ">
    <div class="assembly_title">演练器材
      
      <img src="@/assets/img/drillCenter/line.png" style="width: 78px;height: auto;" alt="">


    </div>
    <div class="assembly_content_box">

   
    <div
      class="assembly_list"
      v-for="(item, index) in safeDrillPlanDevice"
      :key="index"
    >
      <div class="assembly_list_title">
        <img src="@/assets/img/drillCenter/dian.png" style="width: 7px;height: 7px;margin-right: 5px;" alt="">

        {{ item.equipmentName }}  
      </div>
      <div style="text-align: center;">
        {{ item. equipmentAddress}}
      </div>
      <!-- <div class="line"></div> -->
      <div style="text-align: right;" class="assembly_list-position">
        {{ item.equipmentNum  }}
      </div>
    </div>
  </div>  
  </el-col>
</template>
<script>
export default {
  name: "drillCenterEquipment",
  components: {},
  props: {
    safeDrillPlanDevice: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {},
  destroyed() {}
};
</script>
<style lang="scss" scoped>
.assembly_box {
  float: left;
  height: 100%;
  // border: 2px solid #191919;
  // padding-bottom: 2rem;
  padding:  2rem 0; 
  border-left: none;
  border-right: none;
  overflow: hidden;
}
.assembly_content_box{
  overflow: scroll;
  height: 100%;
}
.assembly_list {
  // width: 100%;
  font-size:14px;
  display: flex;
  padding: 1rem;
  align-items: center;
  color: #fff;
  justify-content: space-between;
  opacity: 0.9;
  // color: #21bf25;
}
.assembly_list div{
  flex: 1;
}
.line{
  border: .5px  dashed #96B6CF;
  margin: 0 8px;
  width: 200px;
  height: 1px;
}
</style>
